import e from"react";import{BaseDatePicker as o}from"../BaseDatePicker.js";const r=({onDayClick:r,...t})=>e.createElement(o,{mode:"single",onDayClick:(e,o,t)=>{r&&(e.setHours(12),r(e,o,t))},...t});export{r as InlineDatePicker};
//# sourceMappingURL=InlineDatePicker.js.map
